/*
 * @Author: 周立伟 1508761480@qq.com
 * @Date: 2022-09-27 10:17:50
 * @LastEditors: 周立伟 1508761480@qq.com
 * @LastEditTime: 2022-10-08 16:18:30
 * @FilePath: \modes\src\router\router.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { lazy } from "react";
// import { Navigate } from "react-router-dom";
const Layout = lazy(() => import("../pages/Layout"));
const Login = lazy(() => import("../pages/Login"));
const Loge = lazy(() => import("../pages/Layout/Loge"));
// const Safetytraining = lazy(() => import("../pages/safetytraining"))
// const Report = lazy(() => import("../pages/safetytraining/report"))
// const Statistics = lazy(() => import("../pages/safetytraining/statistics"))
// const TestDeclare = lazy(() => import("../pages/safetytraining/testDeclare"))
// const TestPlan = lazy(() => import("../pages/safetytraining/testPlan"))
// const Training = lazy(() => import("../pages/safetytraining/training"))

const Safetytraining = lazy(() => import("../pages/Layout/safetytraining"))
const Report = lazy(() => import("../pages/Layout/safetytraining/report"))
const Statistics = lazy(() => import("../pages/Layout/safetytraining/statistics"))
const TestDeclare = lazy(() => import("../pages/Layout/safetytraining/testDeclare"))
const NormalTrain = lazy(() => import("../pages/Layout/safetytraining/normalTrain"))
const ThreeTrain = lazy(() => import("../pages/Layout/safetytraining/threeTrain"))
const TestPlan = lazy(() => import("../pages/Layout/safetytraining/testPlan"))
const Training = lazy(() => import("../pages/Layout/safetytraining/training"))



const RouterList = [
  {
    path: "/Layout",
    element: <Layout />,
    children: [
      {
        path: "/Layout/loge",
        element: <Loge />,
      },
      {
        path: '/Layout/safetytraining',
        element: <Safetytraining />,
        children: [
          {
            //数据统计
            path: '/Layout/safetytraining/report',
            element: <Report />,
          }, {
            //数据上报
            path: '/Layout/safetytraining/statistics',
            element: <Statistics />,
          }, {
            //考试申报
            path: '/Layout/safetytraining/testDeclare',
            element: <TestDeclare />,
          }, {
            //考试计划
            path: '/Layout/safetytraining/testPlan',
            element: <TestPlan />,
          }, {
            path: '/Layout/safetytraining/training',
            element: <Training />,
          }, {
            path: '/Layout/safetytraining/normalTrain',
            element: <NormalTrain />,
          }, {
            path: '/Layout/safetytraining/threeTrain',
            element: <ThreeTrain />,
          }
        ]
      }
    ]
    // children: [
    //   {
    //     path: "/Layout",
    //     // element: <Navigate to="/Layout/Housing" />,
    //     element:<Layout/>,
       
    //   },
    // ],
  },
  {
    path: "/",
    element: <Login />,
  },
  // {
  //   path: '/safetytraining',
  //   element: <Safetytraining />,
  //   children: [
  //     {
  //       path: '/safetytraining/report',
  //       element: <Report />,
  //     }, {
  //       path: '/safetytraining/statistics',
  //       element: <Statistics />,
  //     }, {
  //       path: '/safetytraining/testDeclare',
  //       element: <TestDeclare />,
  //     }, {
  //       path: '/safetytraining/testPlan',
  //       element: <TestPlan />,
  //     }, {
  //       path: '/safetytraining/training',
  //       element: <Training />,
  //     }
  //   ]
  // }
];

export default RouterList;
